import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Chunk } from '../../chunk.dto';
import { TagCreatorComponent } from '../../tag-creator/tag-creator.component';

@Component({
  selector: 'app-add-tag-option',
  standalone: true,
  imports: [TranslateModule, MatIconModule, MatDialogModule],
  template: `
    <div class="interactive-item" (click)="onClick()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">label</mat-icon>
        <span class="interactive-item__text">{{ 'ChunkDisplayer.chunkOptions.AddTag' | translate }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddTagOptionComponent {
  @Input() chunk: Chunk;
  @Input() courseID: string;
  @Input() blogID: string;
  @Output() actionTriggered = new EventEmitter<void>();

  private dialog = inject(MatDialog);

  onClick(): void {
    this.dialog.open(TagCreatorComponent, {
      data: {
        chunk: this.chunk,
        courseID: this.courseID,
        blogID: this.blogID,
      },
      disableClose: true,
      width: '90vw',
      maxWidth: '800px',
    });
    this.actionTriggered.emit();
  }
}
